import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';
import gql from 'graphql-tag';
import { SimpleLoadingComponent } from '../../utils/apollo';
import { withEnabledFeatures } from '../../utils/features';
import PageTitle from '../../components/PageTitle';
import ReactHubs from './hubsReact';
import Icon from '../../components/Icon';
import * as constants from '../Authorization/constants';
import './styles.css';

const messages = defineMessages({
  hubsMockDataMessage: {
    id: 'college-profile.view.mock',
    defaultMessage: 'This College Profile Page is using mock student data to replicate a student experience.',
  },
});

export class CollegeProfileViewReactNext extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    params: PropTypes.shape({
      collegeId: PropTypes.string,
      scid: PropTypes.string,
    }).isRequired,
    current: PropTypes.shape({
      viewer: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        idToken: PropTypes.object,
      }).isRequired,
    }).isRequired,
    history: PropTypes.object,
    node: PropTypes.object,
    isEditMode: PropTypes.bool,
    editData: PropTypes.object,
    viewer: PropTypes.object,
    enabledFeatures: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.highSchool = { latitude: 39.103119, longitude: -84.512016 };
  }

  createUserService() {
    const { highSchool } = this;
    const enabledFeatures = get(this.props, 'enabledFeatures', []);

    return {
      getUserInfo() {
        return Promise.resolve({
          permissions: {
            colleges: ['scholarship_match'], // HE app can always see scholarship_match components
          },
          featureFlags: {
            releaseSharedScholarships: enabledFeatures.includes(constants.SCHOLARSHIPS_SUBSCRIPTION), // pass feature flag from HE
            featureMatchHubsIntersectYouVisitTours: enabledFeatures.includes(constants.FEATURE_MATCH_HUBS_INTERSECT_YOUVISITTOURS),
          },
          userData: {},
          highSchool,
        });
      },
      getHighschoolCollegeInfo() {
        return Promise.resolve({
          visits: [],
          registrations: [],
          overlaps: {},
          comment: '',
          scattergram: {},
        });
      },
      getStudentCollegeInfo() {
        return Promise.resolve({
          deliveryType: '',
          collegeContact: {},
          thinkingAbout: [],
          applyingTo: [],
        });
      },
      favorite(scid) {
        return false;
      },
      unfavorite(scid) {
        return false;
      },
      initFavorite(status) {
        return status;
      },
      isHE: true,
    };
  }

  render() {
    const apiUrl = process.env.COLLEGEPROFILE_API_URL;
    // we can get the SCID from the route params or from a graphql query
    const {
      intl,
      history,
      isEditMode,
      current,
      editData,
      params,
      node,
    } = this.props;
    const paramScid = get(params, 'scid');
    const gqlScid = get(node, 'codes.SCID');
    const scid = paramScid || gqlScid;
    const session = { jwt: current.viewer.jwtToken, authType: 'Bearer', institution: current.viewer.idToken['custom:institution'] };
    return (
      session.jwt && scid && (
        <React.Fragment>
          {isEditMode !== true && <PageTitle title="College Profile" category="Naviance" />}
          <div styleName="hubsMockDataMessage">
            <Icon name="exclamation circle" size="large" />
            {intl.formatMessage(messages.hubsMockDataMessage)}
          </div>
          <ReactHubs
            session={session}
            scid={parseInt(scid, 10)}
            fcService={this.createUserService()}
            apiUrl={apiUrl}
            history={history}
            isEditMode={isEditMode}
            editData={editData}
          />
        </React.Fragment>
      )
    );
  }
}

export const CollegeProfileViewReactNextComponent = injectIntl(CollegeProfileViewReactNext);

const query = gql`
  query node($id: ID!) {
    viewer {
      id
      enabledFeatures
    }
    node(id: $id) {
      id
      ... on CollegeCore {
        codes {
          SCID
        }
      }
    }
  }
`;

// use 'skip' to NOT call this query if we received the scid as a param in the route
const graphqlData = graphql(query, {
  skip: ({ params }) => (!!params?.scid),
  options: ({ params }) => {
    const { collegeId } = params;
    return {
      variables: {
        id: btoa(`CollegeCore:${collegeId}`),
      },
    };
  },
});

const mapStateToProps = (state) => ({
  current: state.current,
});

export default SimpleLoadingComponent(
  compose(withEnabledFeatures, graphqlData),
  connect(mapStateToProps),
)(CollegeProfileViewReactNextComponent);
